import React, { useState, useEffect } from 'react'
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid,
    Box
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import SearchGridSSP from '../../components/table/SearchGrid_SSP'
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';

import TotalIcon from "../../assets/img/icons/total.svg";
import Submitted from "../../assets/img/action/Submitted.svg";
import PendingIcon from "./../../assets/img/icons/pendingicon.svg";
import RejectedIcon from "./../../assets/img/icons/DonationFailed.svg";
import DeliveredIcon from "./../../assets/img/icons/deliveredicon.svg";
import ActionIcon from '../../assets/img/action/action.svg';
import { PostDataAPI } from '../../Services/APIService';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import Loader from "../../components/Loader/Loader";
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
import AddProgram from './components/AddProgram';
import ChangeDocument from './changeDocument/ChangeDocument';
import ClearIcon from '@material-ui/icons/Clear';
import PreviewDialog from "./preview/Preview";
import PrintIcon from './../../images/icons/PrintIcon.png';
import { formateMdnNumber, getFormatedDate, formatDate, formatDateYMD, formatDateTime, formatDateTime2, formatNumberWithCommas, getConfiguration } from '../../components/Common/Extensions';
import { HealthcareTabletProgram, HealthcareTabletProgramApplyFor } from '../../components/Common/AppEnums';
import { Table, TableRow, Collapse, Empty, Dropdown, message, Menu, Typography, Tag } from 'antd';
import Edit from './components/Edit/Edit';
import ActivationDetails from './components/activationDetails/ActivationDetails';
import BeneficiariesDialog from './components/beneficiaries/BeneficiariesDialog';
import SendQRDialog from './components/QRCode/SendQRDialog';
import { useHistory } from "react-router-dom";
import PickupEmail from './pickupEmail/PickupEmail';
import SimCardIcon from '@material-ui/icons/SimCard';
import SignalCellularNoSimIcon from '@material-ui/icons/SignalCellularNoSim';
import AskForReview from './reviewRequest/ReviewRequest'
import * as signalR from "@microsoft/signalr";
import Tooltip from '@material-ui/core/Tooltip';

function FloridaConnect({ applicationType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const history = useHistory();
    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const [isPreviewMode, setIsPreviewMode] = useState(false);
    const [appProgram, setAppProgram] = useState(false);

    const [activationDetails, setActivationDetails] = useState(false);
    const [reviewRequest, setReviewRequest] = useState(false);
    const [editRecordObj, setEditRecordObj] = useState({});
    const [changeDocumentAction, setChangeDocumentAction] = useState('');
    const [changeDocument, setChangeDocument] = useState(false)
    const [picupEmail, setPickupEmail] = useState(false);
    const [isSendPickUpEmail, setIsSendPickUpEmail] = useState(false);
    const [selectedApplicationIds, setSelectedApplicationIds] = useState([]);
    const [applicationId, setApplicationId] = useState(0);
    const [applicationsCount, setApplicationsCount] = useState([]);
    const OpenPickupEmail = (item) => {
        setEditRecordObj(item);
        setPickupEmail(true)
    }



    
    const ClosePickupEmail = () => {
        setPickupEmail(false)
    }

    const [editRequest, setEditRequest] = useState(false);

    const [previewDialog, setPreviewDialog] = useState(false);

    const [beneficiariesDialog, setBeneficiariesDialog] = useState(false);
    const [beneficiariesData, setBeneficiariesData] = useState([]);

    const [beneficiaryPreviewDialog, setBeneficiaryPreviewDialog] = useState(false);
    const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);

    const [sendQRDialog, setSendQRDialog] = useState(false);
    const [selectedQRBeneficiary, setSelectedQRBeneficiary] = useState(null);

    const OpenSendQRDialog = (child) => {
        setSelectedQRBeneficiary(child);
        setSendQRDialog(true);
    };

    const CloseSendQRDialog = () => {
        setSendQRDialog(false);
        setSelectedQRBeneficiary(null);
    };
    const CloseSuccessQRDialog = () => {
        CloseSendQRDialog();
        CloseBeneficiariesDialog();
        loadApplicationsGrid();
    };
    const OpenQRCodeDialog = (item) => {
        setEditRecordObj(item);         
        setSelectedQRBeneficiary(null); 
        setSendQRDialog(true);           
    };
    const OpenBeneficiariesDialog = (item) => {
        setEditRecordObj(item);
        setBeneficiariesData(item.programBeneficiaries || []);
        setBeneficiariesDialog(true);
    };

    const CloseBeneficiariesDialog = () => {
        setBeneficiariesDialog(false);
        setBeneficiariesData([]);
        setEditRecordObj({});
    };
    const OpenBeneficiaryPreview = (child) => {
        setSelectedBeneficiary(child);
        setBeneficiaryPreviewDialog(true);
    };

    const CloseBeneficiaryPreview = () => {
        setBeneficiaryPreviewDialog(false);
        setSelectedBeneficiary(null);
    };

    const OpenPreviewDialog = (item) => {
        setEditRecordObj(item);
        setPreviewDialog(true)
    }

    const ClosePreviewDialog = () => {
        setEditRecordObj({});
        setPreviewDialog(false);
    }
    const OpenChangeDocument = () => {
        setChangeDocument(true)
    }
    const OpenEditRequest = () => {
        setEditRequest(true)
    }
    const CloseChangeDocument = () => {
        setChangeDocument(false)
    }

    const editAttachments = (item) => {
        setEditRecordObj(item);
        setChangeDocument(true)
    }

    const editAppProgram = (item) => {
        setEditRecordObj(item);
        setEditRequest(true)
    }
    const addDelivery = (item) => {
        setEditRecordObj(item);
        setAppProgram(true)
    }
    const OpenAppProgram = () => {
        setEditRecordObj({});
        
        setAppProgram(true)
    }

    const CloseAppProgram = () => {
        setEditRecordObj({});
        setAppProgram(false)
    }


    const OpenActivationDetail = (item) => {
        setEditRecordObj(item);
        setActivationDetails(true)
    }

    const CloseActivationDetail = () => {
        setEditRecordObj({});
        setActivationDetails(false)
    }
    const OpenAskForReview = (applicationId) => {
        if (applicationId > 0) {
            setApplicationId(applicationId);
            setApplicationsCount(1);
            setReviewRequest(true);
        }
        else {
            var params = [applicationType, HealthcareTabletProgram.FloridaConnect]
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/getHCTCountbyStatus", params, true).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    setApplicationId(0);
                    setApplicationsCount(result.data);
                    setReviewRequest(true);
                }
                else {
                    showMessage("Error", "No record exists to send review request", "error", 3000);
                }

            })
        }

    }

    const CloseAskForReview = (message) => {
        setSelectedApplicationIds([])
        showMessage("Success", message, "success", 3000);
        setReviewRequest(false)
    }
    const CloseEditRequest = () => {
        setEditRequest(false);
        setEditRecordObj({});
    }
    const AppProgramSuccessClose = (message) => {
        loadTabletStats()
        showMessage("Success", message, "success", 3000);
        setAppProgram(false);
        CloseChangeDocument();
        setEditRecordObj({});
    }
    const EditRequestSuccessClose = (message) => {
        loadTabletStats()
        showMessage("Success", message, "success", 3000);
        setEditRequest(false);
        //CloseChangeDocument();
        setEditRecordObj({});
    }
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('');

    const handleClearInput = (name) => {
        setValue('');
        //handleDataGridUpdate();
        loadApplicationsGrid(currentPage, pageSize, true, sortColumn, sortOrder);
    };

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({
        confirmed: '', shipped: '', inTransit: '', delivered: '', returned: '',
        claimed: '', voided: '', deleted: ''
    });
    const [isLoading, setIsLoading] = useState(false);



    const applicationsStatusBoxes = [
        {
            value: 'Total',
            status: 'Total',
            numbers: '00',
            Icon: TotalIcon,
        },
        {
            value: 'Pending',
            status: 'Pending',
            numbers: '00',
            Icon: PendingIcon,

        },
        {
            value: 'Rejected',
            status: 'Rejected',
            numbers: '00',
            Icon: RejectedIcon,

        },
        {
            value: 'Delivered',
            status: 'Delivered',
            numbers: '00',
            Icon: DeliveredIcon,

        }

    ]

    const [applicationsData, setApplicationsData] = useState([]);

    const triggerMenu = (type) => {
        if (filteredApplicationsData && filteredApplicationsData.length > 0) {
            const applicationIds = filteredApplicationsData.map(item => item.applicationId);
            const postData = {
                applicationIds: applicationIds,
                type: type,
                applicationType: applicationType,
                program: HealthcareTabletProgram.FloridaConnect
            };
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/exportApplications", postData).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    if (type == 'print' || type == 'pdf') {
                        handlePrint(result.data);
                    } else {
                        window.open("." + result.data, "_blank")
                    }

                } else {

                }
            })
        } else {
            showMessage("Error", "No record exists", "error", 3000);
        }


    }
    const exportProgramAnalytics = () => {

        const postData = {
            type: 'analytics',
            applicationIds: [],
            applicationType: '',
            program: HealthcareTabletProgram.FloridaConnect
        };
        setIsLoading(true);
        PostDataAPI("fdnmcchromicconnect/exportApplications", postData).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                window.open("." + result.data, "_blank");
            }
            else {
                showMessage("Error", "No record exists", "error", 3000);
            }
        })
    }


    const [searchFilter, setValue] = useState('');
    const handleSearchKeyPress = (e) => {
        const currValue = searchFilter;

        if (e.charCode == 13 && currValue && currValue.trim().length > 0) {
            //setValue(currValue);
            //handleDataGridUpdate();
            loadApplicationsGrid();
        }
    }
    //const [searchFilter, setSearchFilter] = useState('');
    const handleInputChange = (event) => {
        setValue(event.target.value);
    };
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const handleActionClick = (key, item) => {
        setPreviewDialog(false);
        setEditRecordObj({})
        switch (key) {
            case 'delete':
                deleteApplicationForm(item);
                break;
            case 'reject':
                rejectApplicationForm(item);
                break;
            case 'edit':
                setIsSendPickUpEmail(false)
                editAppProgram(item);
                break;
            case 'delivery':
                addDelivery(item);
                break;
            case 'pickupEmail':
                setIsSendPickUpEmail(true)
                editAppProgram(item);
                break;
            case 'print':
                printApplicationForm(item);
                break;
            case 'editReceivingPicture':
                setChangeDocumentAction('receiving');
                editAttachments(item);
                break;
            case 'editPersonalIdentity':
                setChangeDocumentAction('identity');
                editAttachments(item);
                break;
            case 'preview':
                OpenPreviewDialog(item)
                break;
            case 'beneficiariesDetail':
                OpenBeneficiariesDialog(item);
                break;
            case 'sendQRCode':
                OpenQRCodeDialog(item);
                break;
            case 'activate':
                handleActivateClick(item)
                break;
            case 'askForReview':
                //setSelectedApplicationIds([item.applicationId]);
                //setReviewRequest(true)
                OpenAskForReview(item.applicationId);
                break
            case 'undoRejection':
                undoRejection(item);
                break;
            case 'activationDetails':
                OpenActivationDetail(item);
                break;
            default:
                break;
        }

    }
    const undoRejection = (item) => {
        showActionDialog('Are you sure you want to undo rejection for the application PB-' + (item.ssn ? item.ssn : item.tin) +(item.version && item.version > 0 ? "-" + item.version : "") + '?', "confirm", function () {
            var params = { applicationId: item.applicationId }
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/undoReject", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Application rejection undone successfully", "success", 3000);
                    loadTabletStats();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });

    }
    const handleActivateClick = (record) => {
        //activate sim and get new number here
        var params = {
            applicationId: record.applicationId,
            iCC: record.icc,
            iMEI: record.deviceIdentification,
            cycleDay: new Date().getDate(),
            firstName: record.firstName,
            lastName: record.lastName,
            address1: record.address1,
            address2: record.address2,
            city: record.city,
            phone: record.phone,
            state: record.state,
            zip: record.zipCode,
            emailAddress: record.email
        }
        setIsLoading(true);
        PostDataAPI("fdnmcchromicconnect/activatePrepaidNumber", params, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                //setState(prevState => ({
                //    ...prevState,
                //    assignedPhoneNumber: result.data.assignedPhoneNumber,
                //    accountNumber: result.data.accountNumber
                //}));
                showMessage("Success", "SIM card activated successfully.", "success", 3000);
                loadApplicationsGrid();
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        });
    }

    const UpdateBillingCycleForAllDeliveredRecepients = () => {
        setIsLoading(true);
        // const accountNumbers = filteredApplicationsData.map(application => application.accountNumber);
        PostDataAPI("fdnmcchromicconnect/updateBillingCycle").then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                showMessage("Success", "Billing Cycle Updated Successfully.", "success", 3000);
                loadApplicationsGrid();
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        });
    }


    const handlePrint = (_htmlContent) => {
        debugger
        const newWindow = window.open('', '_blank');
        newWindow.document.open();
        newWindow.document.write(_htmlContent);
        newWindow.document.close();
    }

    const printApplicationForm = (item) => {
        setIsLoading(true)
        var params = { applicationId: item.applicationId, status: item.status, program: item.program };
        PostDataAPI("fdnmcchromicconnect/printApplication", params).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {

                handlePrint(result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    };
    const batchPrintrintApplications = (item) => {
        if (filteredApplicationsData && filteredApplicationsData.length > 0) {
            const applicationIds = filteredApplicationsData.map(item => item.applicationId);
            const postData = {
                applicationIds: applicationIds,
                type: '',
                applicationType: applicationType,
                program: HealthcareTabletProgram.FloridaConnect
            };
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/batchPrintApplications", postData).then((result) => {
                setIsLoading(false);
                if (result.success && result.data) {

                    handlePrint(result.data);
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }

            });
        }
    };

    const [totalRecord, setTotalRecord] = useState();
    const [filteredApplicationsData, setFilteredApplicationsData] = useState();
    const [totalRows, setTotalRows] = useState(0);
    const [filteredStatus, setFilteredStatus] = useState(applicationType === 'requests' ? "Pending" :
        (
            applicationType === 'rejected' ? "Rejected" :
                "Delivered"
        ));

    const handleStatusClick = (event, status) => {
        if (status == "Pending") {
            history.push({
                pathname: "/app/floridaConnect/request",
                state: { applicationType: "requests" }
            });
        }
        else if (status == "Rejected") {
            history.push({
                pathname: "/app/floridaConnect/rejected",
                state: { applicationType: "rejected" }
            });
        }
        else if (status == "Delivered") {
            history.push({
                pathname: "/app/floridaConnect/delivered",
                state: { applicationType: "delivered" }
            });
            history.push("/app/floridaConnect/delivered");
        }
    }

    const topActions = [
        { key: 'print', label: 'Print' },
        { key: 'csv', label: 'CSV' },
        { key: 'excel', label: 'Excel' }
    ];
    const [totalCount, setTotalCount] = useState();
    const [pendingCount, setPendingCount] = useState();
    const [rejectedCount, setRejectedCount] = useState();
    const [deliveredCount, setDeliveredCount] = useState();
    const loadTabletStats = () => {
        setIsLoading(true);
        var params = { program: HealthcareTabletProgram.FloridaConnect }
        PostDataAPI("fdnmcchromicconnect/loadTabletStats", params).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                setTotalCount(result.data.total);
                setPendingCount(result.data.pending);
                setRejectedCount(result.data.rejected);
                setDeliveredCount(result.data.delivered);
                loadApplicationsGrid();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }
    const handleGridChange = (page, pageSize, isClearSearch, sortColumn, sortOrder) => {
        setCurrentPage(page);
        setPageSize(pageSize);
        setSortColumn(sortColumn);
        setSortOrder(sortOrder);
        loadApplicationsGrid(page, pageSize, isClearSearch, sortColumn, sortOrder);
    }
    const loadApplicationsGrid = (page, pageSize, isClearSearch, sortColumn, sortOrder) => {
        setIsLoading(true);
        var selectedStatus = 'Applied';
        if (applicationType === 'rejected')
            selectedStatus = 'Rejected';
        else if (applicationType === 'delivered')
            selectedStatus = 'Delivered';

        var param = {
            extraParams: [selectedStatus, HealthcareTabletProgram.FloridaConnect, isClearSearch ? '' : searchFilter],
            pageSize: pageSize,
            pageNumber: page,
            sortColumn: sortColumn ? sortColumn : '',
            sortOrder: sortOrder ? sortOrder : '',
        };
        PostDataAPI("fdnmcchromicconnect/loadGrid", param).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                setTotalRecord(result.data);
                setTotalRows(result.dataCount);
                const filteredItems = result.data;
                var record = filteredItems.map((item, i) => {
                    var version = item.version && item.version > 0 ? "-" + item.version : "";
                    item.formatedApplicationId = "FC-" + (item.ssn ? item.ssn : item.tin) + version;
                    item.formatedPhone = formateMdnNumber(item.phone);
                    item.emailAddress = item.email;
                    item.completeAddress = item.address1 + " " + (item.address2 ? item.address2 + ", " : ",") + item.city + ', ' + item.state + ' ' + item.zipCode;
                    item.dob = formatDate(item.dateOfBirth);
                    item.dateOfBirth = item.dateOfBirth?.split('T')[0];
                    item.deliveryDate = item.deliveryDate? formatDateTime((item.deliveryDate ? item.deliveryDate.split('T')[0] : '') + (item.deliveryTime ? ' ' + item.deliveryTime : '')):'';
                    item.rejectedDate = formatDateTime(item.rejectedDate ? item.rejectedDate : '');
                    //apply condition here for status
                    item.status = item.status == 'Applied' ? 'Pending' : item.status;
                    item.applyForText = item.applyFor == HealthcareTabletProgramApplyFor.Beneficiary ? 'Children' : HealthcareTabletProgramApplyFor.Self;
                    item.simActivated = item.status == 'Delivered' && item.assignedPhoneNumber && item.assignedPhoneNumber.length > 0 ? <Tooltip title="SIM card activated"><SimCardIcon style={{ color: '#3ecb3e' }}></SimCardIcon></Tooltip> : <Tooltip title="SIM card not activated"><SignalCellularNoSimIcon style={{ color: '#a4a4a4' }}></SignalCellularNoSimIcon></Tooltip>
                    if (item.pickUpFromTime) {
                        item.pickupDateTime = item.pickUpDate.split('T')[0] + ' ' + item.pickUpFromTime
                        item.isPickupEmailSent = true;
                        item.isPickupDatePassed = new Date() > new Date(item.pickupDateTime);
                    }

                    return { ...item };
                })
                setApplicationsData(record);
                setFilteredApplicationsData(record);
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }

    const rejectApplicationForm = (item) => {
        showActionDialog("Are you sure you want to reject the application PB-" + (item.ssn ? item.ssn : item.tin)  +(item.version && item.version > 0 ? "-" + item.version : "") + "?", "confirm", function () {
            var params = { applicationId: item.applicationId, program: item.program }
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/reject", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Application rejected successfully", "success", 3000);
                    loadTabletStats();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }


    const deleteApplicationForm = (item) => {
        showActionDialog("Are you sure you want to delete the application PB-" + (item.ssn ? item.ssn : item.tin) +(item.version && item.version > 0 ? "-" + item.version : "") + "?", "confirm", function () {
            var params = { applicationId: item.applicationId }
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/delete", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Application deleted successfully", "success", 3000);
                    loadTabletStats();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }

    const getRequestStatusCount = (status) => {

        if (status == 'Total') {
            return totalCount;
        }
        else if (status == 'Pending') {
            return pendingCount;
        } else if (status == 'Delivered') {
            return deliveredCount;
        }
        else if (status == 'Rejected') {
            return rejectedCount;
        }
    }

    const getReviewRequestsEmailSentStatus = () => {
        let baseUrl = sessionStorage.getItem('server_api_url');
        //alert(baseUrl);
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(baseUrl.replace("/api", "") + "ffHub")
            .build();

        connection.on("SheilaTablet", (signalRConnectionId) => {
            if (signalRConnectionId == sessionStorage.getItem('signalRConnectionId')) {
                showMessage("Success", "Review requests sent successfully.", "success", 3000);
            }
        });

        connection.start().then(() => {
            const signalRConnectionId = sessionStorage.getItem('signalRConnectionId');
            console.log('Connection ID:', signalRConnectionId);
        }).catch(err => console.error(err));

        return () => {
            connection.stop();
        };
    }
    const handleGetConfigurationSuccess = (configData) => {
        if (configData.UseDummyStats == "true") {
            setTotalCount(configData.TotalCount);
            setPendingCount(configData.PendingCount);
            setRejectedCount(configData.RejectedCount);
            setDeliveredCount(configData.DeliveredCount);
            loadApplicationsGrid();
        }
        else {
            loadTabletStats();
        }
    }
    useEffect(() => {
        //getConfiguration('TabletProgramConfig', handleGetConfigurationSuccess);
        loadTabletStats();
        getReviewRequestsEmailSentStatus();
        setFilteredStatus(applicationType === 'requests' ? "Pending" :
            (
                applicationType === 'rejected' ? "Rejected" :
                    "Delivered"));
    }, [applicationType]);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Florida Connect Program"} isBack={true} currentLink={applicationType == 'requests' ? 'Requests' :
                            (
                                applicationType == 'rejected' ? 'Rejected' :
                                    'Delivered'
                            )}></Breadcrums>
                    </Grid>
                </Grid>

            </div>



            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>

                    {applicationsStatusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.status) }}
                                        checked={filteredStatus === item.status}
                                    />
                                }
                                label={<>
                                    <div className={item.status == "Total" ? classes.statusBoxes + " " + "Total" :
                                        item.status == "Pending" ? classes.statusBoxes + " " + "Pending" :
                                            item.status == "Delivered" ? classes.statusBoxes + " " + "Delivered" :
                                                item.status == "Rejected" ? classes.statusBoxes + " " + "Rejected" :
                                                    ''

                                    }>

                                        <div className={classes.statusBoxContent}>
                                            <span>
                                                {formatNumberWithCommas(getRequestStatusCount(item.status))} </span>
                                            <h3>{item.value}

                                            </h3>
                                        </div>
                                        <img src={item.Icon} />

                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid row className={classes.gridHeader}>
                {applicationType == 'requests' ?
                    <div style={{ marginRight: 'auto' }}>
                        <div className={classes.legend}>

                            <Box className={classes.colorIndicator} style={{ backgroundColor: 'green' }}></Box>
                            <Typography>Pickup Email Sent</Typography>

                            <Box className={classes.colorIndicator} style={{ backgroundColor: 'red' }}></Box>
                            <Typography>Pickup Date Passed</Typography>

                            <Box className={classes.colorIndicator} style={{ backgroundColor: '#ffa500' }}></Box>
                            <Typography>Rejection Undone</Typography>

                        </div>
                    </div>
                    : ''}
                {/*<Button className={classes.changeBtn} onClick={UpdateBillingCycleForAllDeliveredRecepients}>Billing Cycle Update</Button>*/}
                {applicationType == 'delivered' && filteredApplicationsData && filteredApplicationsData.length > 0 ? <Button className={classes.changeBtn} onClick={OpenAskForReview}>Ask for Reviews</Button> : ''}
                <Button className={classes.changeBtn} onClick={loadTabletStats}>Refresh</Button>
                <Button className={classes.changeBtn} onClick={exportProgramAnalytics}>Export Analytics</Button>
                {/*{applicationType == 'delivered' ?*/}
                <Button className={classes.changeBtn} onClick={batchPrintrintApplications}>Batch Print</Button>
                {/*: ''}*/}
                <div className={classes.gridActions}>

                    <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                topActions.map((menuItem, index) => {
                                    return <Menu.Item

                                        key={menuItem.key}
                                        onClick={() => triggerMenu(menuItem.key)}
                                    > <img src={menuItem.icon} /> {menuItem.label}
                                    </Menu.Item>
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn}>
                                Export <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>

                    <Button className={classes.changeBtn} onClick={OpenAppProgram}>Application Form</Button>

                    {/*{applicationType == 'Delivered' ? <Button className={classes.changeBtn} onClick={OpenAppProgram}>Application Form</Button> :''}*/}
                </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <Tooltip title="Search & Press 'Enter'" placement="top">
                        <InputBase
                            value={searchFilter}
                            placeholder="Type & Enter"
                            className="grid-search-input"
                            startAdornment={<SearchIcon />}
                            onChange={handleInputChange}
                            onKeyPress={handleSearchKeyPress}
                            endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        />
                    </Tooltip>
                </div>





            </Grid>

            <Grid row className={classes.container} >

                <SearchGridSSP columns={applicationType == 'requests' ? "FloridaConnectedRequests" :
                    (
                        applicationType == 'rejected' ? "FloridaConnectRejected" :
                            "FloridaConnectDelivered")}
                    list={filteredApplicationsData}
                    totalRows={totalRows}
                    noRecordMsg="No record exists."
                    Icon={true}
                    filter={searchFilter}
                    isUpdate={isDataGridUpdate}
                    onActionClick={handleActionClick}
                    isTopPagination={true}
                    handlePageChange={handleGridChange}
                />
            </Grid>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

            {reviewRequest ?
                <AskForReview
                    dialogOpenClose={OpenAskForReview}
                    handleClose={() => { setReviewRequest(false) }}
                    handleSuccessClose={CloseAskForReview}
                    records={filteredApplicationsData}
                    applicationsCount={applicationsCount}
                    applicationType={applicationType}
                    applicationId={applicationId}
                    program={HealthcareTabletProgram.FloridaConnect}
                ></AskForReview>
                : ''}
            {appProgram ?
                <AddProgram
                    dialogOpenClose={OpenAppProgram}
                    handleClose={CloseAppProgram}
                    handleSuccessClose={AppProgramSuccessClose}
                    record={editRecordObj}
                    program={HealthcareTabletProgram.FloridaConnect}
                ></AddProgram>
                : ''}

            {changeDocument ?
                <ChangeDocument
                    dialogOpenClose={OpenChangeDocument}
                    handleClose={CloseChangeDocument}
                    handleSuccessClose={AppProgramSuccessClose}
                    record={editRecordObj}
                    changeDocumentAction={changeDocumentAction}
                ></ChangeDocument>
                : ''
            }
            {editRequest ?
                <Edit
                    dialogOpenClose={OpenEditRequest}
                    handleClose={CloseEditRequest}
                    handleSuccessClose={EditRequestSuccessClose}
                    record={editRecordObj}
                    isPreviewMode={isPreviewMode}
                    isSendPickUpEmail={isSendPickUpEmail}
                    applicationType={applicationType}
                ></Edit>
                : ''}
            {activationDetails ?
                <ActivationDetails
                    dialogOpenClose={OpenActivationDetail}
                    handleClose={CloseActivationDetail}
                    record={editRecordObj}
                ></ActivationDetails>
                : ''}
            {previewDialog ?
                <PreviewDialog
                    dialogOpenClose={OpenPreviewDialog}
                    handleClose={ClosePreviewDialog}
                    record={editRecordObj}
                >
                </PreviewDialog>
                : ''}

            {beneficiariesDialog ? (
                <BeneficiariesDialog
                    dialogOpenClose={beneficiariesDialog}
                    handleClose={CloseBeneficiariesDialog}
                    record={editRecordObj}
                    beneficiariesData={beneficiariesData}
                    onActionClick={(action, child) => {
                        if (action === 'preview') {
                            OpenBeneficiaryPreview(child);
                        } else if (action === 'sendQR') {
                            OpenSendQRDialog(child);
                        }
                    }}
                />
            ) : ''}

            {beneficiaryPreviewDialog ? (
                <PreviewDialog
                    dialogOpenClose={beneficiaryPreviewDialog}
                    handleClose={CloseBeneficiaryPreview}
                    record={editRecordObj}
                    isBeneficiaryPreview={true}
                    selectedBeneficiary={selectedBeneficiary}
                />
            ) : ''}

            {sendQRDialog ? (
                <SendQRDialog
                    dialogOpenClose={sendQRDialog}
                    handleClose={CloseSendQRDialog}
                    handleSuccessClose={CloseSuccessQRDialog}
                    record={editRecordObj}
                    beneficiary={selectedQRBeneficiary}
                />
            ) : ''}

            {picupEmail ?
                <PickupEmail
                    dialogOpenClose={OpenPickupEmail}
                    handleClose={ClosePickupEmail}
                    record={editRecordObj}
                >
                </PickupEmail>
                : ''}
        </>
    )

}

export default withSnackbar(FloridaConnect);